// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Yp-R1","signatureBlock":"Footer_signatureBlock__3fHqA","signature":"Footer_signature__1QjZo"};